export type NavItem = {
  id: string;
  label: string;
  to: string;
  /** path prefixes that also activate this item (e.g. detail routes) */
  match: string[];
  count?: number;
};

export type NavGroup = {
  id: string;
  title?: string;
  items: NavItem[];
};

export type NavCounts = {
  orgs?: number;
  apps?: number;
  clients?: number;
  federated?: number;
};

/** Grouped sidebar navigation (ported from the prototype app.jsx navGroups()). */
export function getNavGroups(counts: NavCounts = {}): NavGroup[] {
  return [
    {
      id: "g-top",
      items: [{ id: "overview", label: "Übersicht", to: "/", match: ["/"] }],
    },
    {
      id: "g-dir",
      title: "Verzeichnis",
      items: [
        {
          id: "orgs",
          label: "Organisationen",
          to: "/organizations",
          // person-360 (/users/:id) is reached via an org's members, so it
          // activates the Organisationen item (no standalone people list exists).
          match: ["/organizations", "/users"],
          count: counts.orgs,
        },
        {
          id: "apps",
          label: "Applications",
          to: "/applications",
          match: ["/applications"],
          count: counts.apps,
        },
      ],
    },
    {
      id: "g-id",
      title: "Identity",
      items: [
        {
          id: "clients",
          label: "OAuth-Clients",
          to: "/auth-clients",
          match: ["/auth-clients"],
          count: counts.clients,
        },
        {
          id: "federated",
          label: "Föderation",
          to: "/federated-clients",
          match: ["/federated-clients"],
          count: counts.federated,
        },
      ],
    },
    {
      id: "g-sys",
      title: "System",
      items: [{ id: "audit", label: "Audit-Log", to: "/audit", match: ["/audit"] }],
    },
  ];
}

/** Pick the active nav item id for a given pathname (longest match wins, except root). */
export function activeNavId(pathname: string, groups: NavGroup[]): string | null {
  let best: { id: string; len: number } | null = null;
  for (const group of groups) {
    for (const item of group.items) {
      for (const prefix of item.match) {
        const hit = prefix === "/" ? pathname === "/" : pathname.startsWith(prefix);
        if (hit && (!best || prefix.length > best.len)) {
          best = { id: item.id, len: prefix.length };
        }
      }
    }
  }
  return best?.id ?? null;
}
